import React, { useEffect, useState } from 'react';
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';
import { UsersTable } from '../components/users/UsersTable';
import { Stack } from '@mui/system';
import { DialogTemplate } from '../components/dialogs/DialogTemplate';
import { NewUserForm } from '../components/auth/NewUserForm';
import { getUsers } from '../actions/user';
import { useDispatch, useSelector } from 'react-redux';
import { getCatalog } from '../actions/catalogs';

export const Users = () => {
	// Tabs
	const [value, setTab] = useState(0);

	// Dispatch
	const dispatch = useDispatch();

	// Dialog
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	// User types
	const { usertype: USER_TYPES = [] } = useSelector(
		(state) => state.catalogs
	);

	const handleChange = (_, newValue) => {
		setTab(newValue);
	};

	// Dummy users
	const [users, setUsers] = useState([]);

	// Get data from DB
	const getData = () => {
		getUsers().then(({ data }) => {
			setUsers(data.results);
		});
	};

	useEffect(() => {
		dispatch(getCatalog('usertype'));
		dispatch(getCatalog('area'));
		getData();
	}, []);

	// Panel component for each tab
	const TabPanel = (props) => {
		const { children, value, index, ...other } = props;

		return (
			<div
				role='tabpanel'
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
			</div>
		);
	};

	return (
		<Box sx={{ width: '100%' }}>
			<DialogTemplate
				config={{
					open: open,
					handleClose: handleClose,
					btnCancel: false,
					btnConfirm: false,
					title: 'Nuevo registro de usuario',
					subtitle:
						'Complete todo el formulario para crear un nuevo usuario.',
				}}
				content={
					<NewUserForm handleClose={handleClose} refresh={getData} />
				}
			/>
			<Stack
				direction='column'
				alignItems='flex-start'
				justifyContent='space-between'
				mb={1}
				style={{ padding: '20px 0 0 20px' }}
			>
				<Typography variant='h4' gutterBottom>
					Usuarios
				</Typography>
				<Stack
					direction='row'
					alignItems='flex-end'
					justifyContent='space-between'
					style={{
						padding: '20px 20px 0 0',
						width: '100%',
					}}
				>
					{/* We remove 1 item from user types array because
					we're not counting the "super admin" type */}
					<Typography variant='p' gutterBottom>
						Se muestran todos los usuarios categorizados en{' '}
						{USER_TYPES.length - 1} tipos.
					</Typography>
					<Button
						variant='contained'
						style={{ backgroundColor: '#143f6c' }}
						onClick={handleOpen}
					>
						Nuevo usuario
					</Button>
				</Stack>
			</Stack>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label='basic tabs example'
				>
					{USER_TYPES.filter(({ id }) => id !== 1).map((item, i) => (
						<Tab
							label={item.name}
							{...a11yProps(i)}
							key={`tab-label-${item.id}`}
						/>
					))}
				</Tabs>
			</Box>
			{USER_TYPES.filter(({ id }) => id !== 1).map((item, i) => (
				<TabPanel
					value={value}
					index={i}
					key={`tab-label-${item.id}-panel`}
				>
					<UsersTable
						data={users}
						userType={item.name}
						refresh={getData}
					/>
				</TabPanel>
			))}
		</Box>
	);
};

const a11yProps = (index) => {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
};
